import { render, staticRenderFns } from "./UserLoanPaymentRequests.vue?vue&type=template&id=1512419e"
import script from "./UserLoanPaymentRequests.vue?vue&type=script&lang=js"
export * from "./UserLoanPaymentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports